import React, { FC, createContext, ReactNode, useState } from 'react';

type Props = {
  children?: ReactNode;
};

interface IOrganization {
  selectedOrganizationId: string;
}

type OrganizationContextType = {
  selectedOrganizationId: string;
  updateSelectedOrganizationId: (id: string) => void;
};

export const OrganizationsContext = createContext<OrganizationContextType | null>(null);

export const OrganizationsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedOrganizationId, setSelectedOrganizationId] = useState('');
  const updateSelectedOrganizationId = id => {
    setSelectedOrganizationId(id);
  };

  return (
    <OrganizationsContext.Provider value={{ selectedOrganizationId, updateSelectedOrganizationId }}>
      {children}
    </OrganizationsContext.Provider>
  );
};

export const OrganizationsDispatchContext = createContext(null);
